"use strict";
/**
 * __GLOBAL_TARGET__, __GLOBAL_PROP_FN__, __GLOBAL_PROP_NAME__
 * 三个变量均为编译时动态注入，所以请勿引入
 */
if (!__GLOBAL_TARGET__[__GLOBAL_PROP_FN__]) {
    Object.defineProperty(__GLOBAL_TARGET__, __GLOBAL_PROP_FN__, {
        writable: false,
        enumerable: false,
        configurable: false,
        value(name, defaultValue) {
            var _a;
            if (typeof (__GLOBAL_TARGET__ === null || __GLOBAL_TARGET__ === void 0 ? void 0 : __GLOBAL_TARGET__[__GLOBAL_PROP_NAME__]) !== 'undefined') {
                if (typeof ((_a = __GLOBAL_TARGET__[__GLOBAL_PROP_NAME__]) === null || _a === void 0 ? void 0 : _a[name]) !== 'undefined') {
                    return __GLOBAL_TARGET__[__GLOBAL_PROP_NAME__][name];
                }
            }
            return defaultValue;
        },
    });
}
//# sourceMappingURL=find-env.js.map